import React from 'react';
import { useLocalContext } from '../../context/LocalContext';
import './ExpertHelpSection.css';

const ExpertHelpSection = () => {
  const { openSignupModal } = useLocalContext();

  const experts = [
    {
      id: 1,
      name: 'Dr. Sarah Johnson',
      title: 'Relationship Coach',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop',
      specialties: ['Communication', 'Conflict Resolution', 'Dating Strategy'],
      rating: 4.9,
      sessions: 850
    },
    {
      id: 2,
      name: 'Michael Chen',
      title: 'Dating Coach',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop',
      specialties: ['First Dates', 'Profile Optimization', 'Confidence Building'],
      rating: 4.8,
      sessions: 1200
    },
    {
      id: 3,
      name: 'Dr. Emily Williams',
      title: 'Psychologist',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop',
      specialties: ['Self-Esteem', 'Anxiety', 'Attachment Styles'],
      rating: 5.0,
      sessions: 620
    }
  ];

  const services = [
    {
      icon: '💬',
      title: '1-on-1 Coaching',
      description: 'Get personalized advice from certified dating and relationship coaches.'
    },
    {
      icon: '📝',
      title: 'Profile Review',
      description: 'Have your profile reviewed by experts to maximize your matches.'
    },
    {
      icon: '🎭',
      title: 'Dating Strategy',
      description: 'Develop a winning strategy for finding your perfect match.'
    },
    {
      icon: '❤️',
      title: 'Relationship Advice',
      description: 'Get guidance on building and maintaining healthy relationships.'
    }
  ];

  return (
    <div className="expert-page">
      {/* Hero Section */}
      <section className="expert-hero">
        <div className="container">
          <h1 className="expert-hero-title">Expert Help</h1>
          <p className="expert-hero-subtitle">
            Get personalized guidance from certified dating and relationship experts
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="expert-services">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.title} className="service-card">
                <span className="service-icon">{service.icon}</span>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Experts Section */}
      <section className="expert-list">
        <div className="container">
          <h2 className="section-title">Meet Our Experts</h2>
          <p className="section-subtitle">
            Connect with certified professionals who can help you succeed
          </p>
          <div className="experts-grid">
            {experts.map((expert) => (
              <div key={expert.id} className="expert-card">
                <div className="expert-image">
                  <img src={expert.image} alt={expert.name} />
                </div>
                <div className="expert-info">
                  <h3 className="expert-name">{expert.name}</h3>
                  <p className="expert-title">{expert.title}</p>
                  <div className="expert-rating">
                    <span className="rating-star">★</span>
                    <span className="rating-value">{expert.rating}</span>
                    <span className="rating-sessions">({expert.sessions} sessions)</span>
                  </div>
                  <div className="expert-specialties">
                    {expert.specialties.map((specialty) => (
                      <span key={specialty} className="specialty-tag">{specialty}</span>
                    ))}
                  </div>
                  <button className="btn btn-primary btn-sm">Book Session</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps-grid">
            <div className="step-item">
              <div className="step-number">1</div>
              <h3>Choose an Expert</h3>
              <p>Browse our roster of certified coaches and choose one that fits your needs.</p>
            </div>
            <div className="step-item">
              <div className="step-number">2</div>
              <h3>Book a Session</h3>
              <p>Select a convenient time and book your coaching session.</p>
            </div>
            <div className="step-item">
              <div className="step-number">3</div>
              <h3>Get Personalized Advice</h3>
              <p>Connect via video call and receive tailored guidance.</p>
            </div>
            <div className="step-item">
              <div className="step-number">4</div>
              <h3>Apply & Succeed</h3>
              <p>Implement the advice and watch your dating life transform.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="expert-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Dating Life?</h2>
            <p>Join millions of users who have found success with expert guidance.</p>
            <button className="btn btn-primary btn-lg" onClick={openSignupModal}>
              Get Started Today
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ExpertHelpSection;
